:host {
	grid-column: 1 / -1;
	display: grid;
	grid-template-columns: subgrid;
	color: rgb(var(--smoothly-table-foreground));
	background-color: rgb(var(--smoothly-table-background));
}
